import React from 'react';

function TrustSection() {
  return (
    <section className="trust reveal">
      <div className="trust-content">
        <div className="trust-text">
          <h2>Entwickelt aus echter Praxiserfahrung</h2>
          <p>
            TechSoul wurde nicht als theoretisches KI-Projekt entwickelt. Die Plattform
            basiert auf über 15 Jahren Erfahrung in Operations, Führung, Prozessmanagement
            und Serviceorganisation. Jedes Werkzeug entstand aus realen Herausforderungen
            im Arbeitsalltag.
          </p>
        </div>
        <div className="trust-stats">
          <div className="trust-stat">
            <div className="trust-stat__number">15+</div>
            <div className="trust-stat__label">Jahre Erfahrung</div>
          </div>
          <div className="trust-stat">
            <div className="trust-stat__number">100+</div>
            <div className="trust-stat__label">Mitarbeiter geführt</div>
          </div>
          <div className="trust-stat">
            <div className="trust-stat__number">10+</div>
            <div className="trust-stat__label">Jahre Ausbildung</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustSection;
